<template>
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M15 1.5834H5C2 1.5834 0 3.08339 0 6.58336V13.5833C0 17.0833 2 18.5833 5 18.5833H15C18 18.5833 20 17.0833 20 13.5833V6.58336C20 3.08339 18 1.5834 15 1.5834ZM15.47 7.67335L12.34 10.1733C11.68 10.7033 10.84 10.9633 10 10.9633C9.16 10.9633 8.31 10.7033 7.66 10.1733L4.53 7.67335C4.21 7.41335 4.16 6.93336 4.41 6.61336C4.67 6.29336 5.14 6.23336 5.46 6.49336L8.59 8.99334C9.35 9.60333 10.64 9.60333 11.4 8.99334L14.53 6.49336C14.85 6.23336 15.33 6.28336 15.58 6.61336C15.84 6.93336 15.79 7.41335 15.47 7.67335Z"
            fill="#666666"
        />
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
